import CityPageTemplate from "../city-template/CityPageTemplate";
import { catonsvilleConfig } from "./data";

export default function CatonsvillePage() {
  return <CityPageTemplate config={catonsvilleConfig} />;
}